import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const ShopPage = lazy(() => import("../pages/shop/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const GrowPage = lazy(() => import("../pages/grow/page"));
const GuidesPage = lazy(() => import("../pages/guides/page"));
const PestManagementPage = lazy(() => import("../pages/pest-management/page"));
const CommunityPage = lazy(() => import("../pages/community/page"));
const TermsPage = lazy(() => import("../pages/terms/page"));
const PrivacyPage = lazy(() => import("../pages/privacy/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/grow",
    element: <GrowPage />,
  },
  {
    path: "/guides",
    element: <GuidesPage />,
  },
  {
    path: "/pest-management",
    element: <PestManagementPage />,
  },
  {
    path: "/community",
    element: <CommunityPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;